module.exports = __webpack_public_path__ + "static/media/assignment.fba643e4.svg";